import React from 'react';
import { FaEnvelope, FaClock, FaDollarSign } from 'react-icons/fa';
import ApplicationStatus from '../cards/ApplicationStatus';
import '../../css/common/TravelCard.css';

const TravelCard = ({ travel, onClick, onHover }) => {


  return (
    <div 
      className="travel-card-component" 
      onClick={onClick}
      onMouseEnter={onHover}
    >
      <div className="travel-card-content">
        <h3 className="travel-card-name">{travel.name}</h3>
        <div className="travel-card-duration">
          <FaClock className="travel-card-duration-icon" />
          <span>{travel.duration}</span>
        </div>
        <div className="travel-card-cost">
          <FaDollarSign className="travel-card-cost-icon" />
          <span>{travel.cost}</span>
        </div>
        <div className="travel-card-contact">
          <FaEnvelope className="travel-card-email-icon" title={`Contact ${travel.contact.name}`} />
        </div>
        <div className="travel-card-status">
          <ApplicationStatus status={travel.applicationStatus} />
        </div>
      </div>
    </div>
  );
};

export default TravelCard; 